
  <section class="modal-body text-left">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <label class="small text-secondary" for="nit">Nombre de usuario</label>
                <input id="valor" 
                       [matAutocomplete]="auto"
                       formControlName="valor" 
                       (ngModelChange)="onChangeSearch($event)" 
                       type="text" 
                       class="form-control form-control-sm">
                
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option *ngFor="let user of users" 
                                (click)="verifyValid()"
                               value="{{user.usuario}}">
                    {{user.usuario}}
                  </mat-option>
                </mat-autocomplete>
              </div>
        </div>
    </form>
    
  </section>
  <footer class="modal-footer">
    <button class="btn btn-primary w-100" 
            (click)="confirm()"
            [disabled]="!valid">Guardar</button>
  </footer>
   